module.exports = __webpack_public_path__ + "29a4ae90317fe05560f2ff75746c7d69.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/map-bg.svg
 ** module id = 1553
 ** module chunks = 0
 **/